import { Box, Button, Pagination, SegmentedControl, Table, Title } from "@mantine/core";
import { useInputState } from "@mantine/hooks";
import type { JSX } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "urql";
import Loading from "../Loading";
import DeleteButton from "./DeleteButton";
import classes from "./PreviousThreads.module.css";
import { type ThreadPageQuery, type ThreadPageQueryVariables, threadPageQuery } from "./queries";

function PreviousThreads(): JSX.Element {
    const [filter, setFilter] = useInputState("MINE");
    const [page, setPage] = useState(1);
    const [result] = useQuery<ThreadPageQuery, ThreadPageQueryVariables>({
        query: threadPageQuery,
        variables: {
            page,
            filter: filter as ThreadPageQueryVariables["filter"],
        },
    });

    let main = null;
    if (result.fetching) {
        main = <Loading />;
    } else if (result.error) {
        main = <Box>Error: {result.error.message}</Box>;
    } else if (!result.data || result.data.threadPage.maxPage === 0) {
        main = <Box>No previous threads</Box>;
    } else {
        main = (
            <>
                <SegmentedControl
                    className={classes.segmented}
                    value={filter}
                    onChange={setFilter}
                    data={[
                        { label: "Mine", value: "MINE" },
                        { label: "Others", value: "OTHERS" },
                        { label: "All", value: "ALL" },
                    ]}
                />
                <Pagination total={result.data.threadPage.maxPage} value={page} onChange={setPage} />
                <Table>
                    <Table.Thead>
                        <Table.Tr>
                            <Table.Th>Name</Table.Th>
                            <Table.Th>AI personality</Table.Th>
                            <Table.Th>Creator</Table.Th>
                            <Table.Th>Created</Table.Th>
                            <Table.Th>Tokens</Table.Th>
                            <Table.Th colSpan={3} />
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                        {result.data.threadPage.items.map((thread) => (
                            <Table.Tr key={thread.id}>
                                <Table.Td>{thread.threadName || "New chat"}</Table.Td>
                                <Table.Td>{thread.aiPersonality?.name}</Table.Td>
                                <Table.Td>
                                    {thread.user ? `${thread.user.firstName} ${thread.user.lastName}` : ""}
                                </Table.Td>
                                <Table.Td>{new Date(thread.created).toLocaleString("en-GB")}</Table.Td>
                                <Table.Td>{thread.tokens}</Table.Td>
                                <Table.Td>
                                    <Button component={Link} to={`../${thread.id}`}>
                                        Open
                                    </Button>
                                </Table.Td>
                                <Table.Td>
                                    <DeleteButton thread={thread} />
                                </Table.Td>
                            </Table.Tr>
                        ))}
                    </Table.Tbody>
                </Table>
                <Pagination total={result.data.threadPage.maxPage} value={page} onChange={setPage} />
            </>
        );
    }

    return (
        <Box className={classes.grid}>
            <Title order={2}>Previous AI chat conversations</Title>
            {main}
            <Link to="..">Back</Link>
        </Box>
    );
}

export default PreviousThreads;
